import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardStoreService } from 'src/app/shared/services/store/dashboard-store.service';
import { NewItemsCount } from 'src/app/shared/models/new-items-count.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit, OnDestroy {
  newItemsCount: NewItemsCount;

  newItemsCountSubscription: Subscription;
  constructor(private dashboardStore: DashboardStoreService) { }

  ngOnInit() {
    this.dashboardStore.fetch();
    this.dashboardStore.newItemsCount$.subscribe(newItemsCount => this.newItemsCount = newItemsCount);
  }

  ngOnDestroy() {
    if (this.newItemsCountSubscription) {
      this.newItemsCountSubscription.unsubscribe();
    }
    this.dashboardStore.clean();
  }
}
